import { DataType } from "../types/dataType";

export const dummyData: DataType = {
  data: [
    ["20220129", "0", "0"],
    ["20220130", "0", "0"],
    ["20220131", "0", "0"],
    ["20220201", "0", "0"],
    ["20220202", "0", "0"],
    ["20220203", "0", "0"],
    ["20220204", "0", "0"],
    ["20220205", "425", "1"],
  ],
  head: ["ga:date", "ga:pageviews", "ga:sessions"],
  total: { "ga:pageviews": "10000" },
};

export const dummyRound: DataType = {
  data: [
    ["Chrome", "425"],
    ["Safari", "300"],
  ],
  head: ["ga:browser", "ga:pageviews"],
  total: {
    "ga:pageviews": "425",
  },
};
